import { getDocumentDownloadURL } from "../../features/buy/services/buyService";

export const handleDownloadPDF = async (navigate, link, name) => {
  let base64String;

  try {
    base64String = await getDocumentDownloadURL(link, navigate);
  } catch (error) {
    console.error("An error occurred while fetching base64: ", error);
  }

  const byteCharacters = atob(base64String);
  const byteNumbers = new Uint8Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const blob = new Blob([byteNumbers], { type: "application/pdf" });

  // Create a link element and trigger download
  const fileLink = document.createElement("a");
  fileLink.href = URL.createObjectURL(blob);
  fileLink.download = `${name}.pdf`;
  document.body.appendChild(fileLink);
  fileLink.click();
  document.body.removeChild(fileLink);
};

export const downloadTOBA = ({ navigate }) => {
  return handleDownloadPDF(navigate, "api/vault/static/item/1", "TOBA");
};

export const downloadPrivacyPolicy = ({ navigate }) => {
  return handleDownloadPDF(
    navigate,
    "api/vault/static/item/24",
    "PrivacyPolicy"
  );
};

export const downloadCookiePolicy = ({ navigate }) => {
  return handleDownloadPDF(
    navigate,
    "api/vault/static/item/28",
    "CookiesPolicy"
  );
};

export const downloadComplaintPolicy = ({ navigate }) => {
  return handleDownloadPDF(
    navigate,
    "api/vault/static/item/27",
    "ComplaintsPolicy"
  );
};

export const uberDriverTerms = ({ navigate }) => {
  return handleDownloadPDF(
    navigate,
    "api/vault/static/item/29",
    "InsuranceArrangements"
  );
};

export const downloadPreContractAgreement = ({
  navigate,
  riskObjectId,
  riskObjectHistoryId,
}) => {
  const link = `api/vault/template/item/${riskObjectId}/${riskObjectHistoryId}/1480`;
  return handleDownloadPDF(navigate, link, "PCL_PreContract");
};
